import { signInWithPopup, signOut } from "firebase/auth";
import { doc, setDoc, getDoc,Timestamp } from "firebase/firestore";
import { auth, provider, db } from "./firebase";

export const loginWithGoogle = async () => {
  const result = await signInWithPopup(auth, provider);
  const user = result.user;

  const userRef = doc(db, "users", user.uid);
  const userSnap = await getDoc(userRef);

  const now = Timestamp.now();
  const jsDate = now.toDate(); // Convert Firestore Timestamp to JS Date
  
  // Extract year and month
  const year = jsDate.getFullYear();
  const month = jsDate.getMonth(); // 0 = Jan, 1 = Feb, ..., 11 = Dec
  
  // Create start date: 1st of current month at 00:00
  const start_date = Timestamp.fromDate(new Date(year, month, 1, 0, 0, 0));
  
  // Create end date: last day of current month at 23:59:59
  const lastDay = new Date(year, month + 1, 0).getDate(); // Get last day of current month
  const end_date = Timestamp.fromDate(new Date(year, month, lastDay, 23, 59, 59));
  

  if (!userSnap.exists()) {
   
    await setDoc(userRef, {
      uid: user.uid,
      username: user.displayName,
      email: user.email,
      photoURL: user.photoURL,
      createdAt: Timestamp.now(),
      lastLoginAt: Timestamp.now(),
      
      plan_details: {
        isFreeCreditDone:false,
        plan: "FREE",
        start_date: start_date,
        end_date: end_date,
        remaining_prompts: 18,

      },
    });
  } else {
    
    await setDoc(userRef, {
      lastLoginAt: Timestamp.now(),

    }, { merge: true });
  }

  return user;
};

export const logout = async () => {
  await signOut(auth);
};